module.exports = __webpack_public_path__ + "img/section3_m.3e1bf8ab.jpg";